<template>
    <div>
        <b-form>
            <b-col cols="12" class="d-flex justify-content-end">
                <b-button variant="primary" @click="adicionarItem">
                    +
                </b-button>
            </b-col>

            <b-table responsive class="mt-2" small :items="contratoForm.aditivos" :fields="fields" hover>
                <template #cell(tipoAditivo)="data">
                    <LgFinderPageTipoAditivo class="mb-2 mt-2" @input="function (item) { setTipoAditivo(data.item, item) }"
                        v-model="data.item.tipoAditivo" label="" :prefix="prefix" />
                </template>


                <template #cell(valorAnterior)="data">
                    <LgFormInput v-if="data.item.tipoAditivo && data.item.tipoAditivo.id && (data.item.tipoAditivo.id !== TipoAditivoEnum.PRORROGACAO_PRAZO.cod)"  class='mt-3' v-model="data.item.valorAnterior" type="text"
                        @input="formatValorUnit(data.item, data.item.valorAnterior)" />
                </template>


                <template #cell(valorNovo)="data">
                    <LgFormInput v-if="data.item.tipoAditivo && data.item.tipoAditivo.id && (data.item.tipoAditivo.id !== TipoAditivoEnum.PRORROGACAO_PRAZO.cod)" class='mt-3' v-model="data.item.valorNovo" type="text"
                        @input="formatValorUnit(data.item, data.item.valorNovo)" />
                </template>




                <template v-slot:cell(dataInicial)="data">
                    <lg-form-date v-if="data.item.tipoAditivo && data.item.tipoAditivo.id && (data.item.tipoAditivo.id === TipoAditivoEnum.PRORROGACAO_PRAZO.cod)" class="mt-2 mb-2" invalidFeedback=" " description=" " v-model="data.item.dataInicial"
                        label=" " />
                </template>

                <template v-slot:cell(dataFinal)="data">
                    <lg-form-date v-if="data.item.tipoAditivo && data.item.tipoAditivo.id && (data.item.tipoAditivo.id === TipoAditivoEnum.PRORROGACAO_PRAZO.cod)" class="mt-2 mb-2" invalidFeedback=" " description=" " v-model="data.item.dataFinal"
                        label=" " />
                </template>


                <template v-slot:cell(observacao)="data">
                    <lg-form-input class="mt-2 mb-2" v-model="data.item.observacao" label=" " description=" " />
                </template>

                <template v-slot:cell(acoes)="data">
                    <b-button v-if="!isEditMode" size="sm" pill variant="danger" @click="removerAditivo(data.item)">
                        <b-icon icon="trash" />
                    </b-button>
                </template>
            </b-table>
        </b-form>
    </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import LgFinderPageTipoAditivo from "@/components/Finders/LgFinderPageTipoAditivo.vue";
import TipoAditivoEnum from "@/core/utils/TipoAditivoEnum";

export default {
    name: "AditivosForm",
    mixins: [validationMixin],
    components: { LgFinderPageTipoAditivo, LgFormDate, LgFormInput },
    props: {
        prefix: {
            type: String,
            default: "",
        },
        contratoFormProp: {
            type: Object,
            required: true,
        },
        isEditMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            TipoAditivoEnum:TipoAditivoEnum,
            contratoForm: this.contratoFormProp,
            fields: [
                { key: "numeroAditivo", label: "Número do Aditivo" },

                { key: "tipoAditivo", label: "Tipo de Aditivo" },
                { key: "valorAnterior", label: "Valor Antigo" },
                { key: "valorNovo", label: "Valor novo" },

                { key: "dataInicial", label: "Data Inicial" },
                { key: "dataFinal", label: "Data Final" },
                { key: "observacao", label: "Observação" },
                { key: "acoes", label: "Ações", class: "text-center" },
            ],
        };
    },
    methods: {
        setTipoAditivo(item, tipo) {
            item.tipoAditivo = tipo;
        },
        formatValorUnit(item, valor) {
            item.valor = valor.replace(',', '.')
        },

        adicionarItem() {
            this.contratoForm.aditivos.push({ valorAnterior: "", valorNovo: "", tipoAditivo: {}, numeroAditivo: "", observacao: "", })
        },

        removerAditivo(index) {
            this.contratoForm.aditivos.splice(index, 1);
        },

    },
};
</script>

<style scoped>
.mt-2 {
    margin-top: 0.5rem;
}

.ml-2 {
    margin-left: 0.5rem;
}

.mt-3 {
    margin-top: 1rem;
}
</style>
